import { render, staticRenderFns } from "./ScopeWelcomePanel.vue?vue&type=template&id=76ac1ba4&scoped=true"
import script from "./ScopeWelcomePanel.vue?vue&type=script&lang=js"
export * from "./ScopeWelcomePanel.vue?vue&type=script&lang=js"
import style0 from "./ScopeWelcomePanel.vue?vue&type=style&index=0&id=76ac1ba4&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76ac1ba4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/CFDE Knowledge - Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('76ac1ba4')) {
      api.createRecord('76ac1ba4', component.options)
    } else {
      api.reload('76ac1ba4', component.options)
    }
    module.hot.accept("./ScopeWelcomePanel.vue?vue&type=template&id=76ac1ba4&scoped=true", function () {
      api.rerender('76ac1ba4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/customComponents/revealScope/ScopeWelcomePanel.vue"
export default component.exports